import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DefaultButton, Dropdown, MessageBar, MessageBarType, Spinner, Stack, } from "@fluentui/react";
import * as React from "react";
import { useLocaleStrings } from "../../../library/providers/strings";
const CustomerMsSalesIdSelector = ({ candidates, selectedSalesId, lookupStatus, onSelectionChange, onRetry, }) => {
    const { getLocalSpecificString } = useLocaleStrings();
    const [hasInteracted, setHasInteracted] = React.useState(false);
    const dropdownRef = React.useRef(null);
    const retryButtonRef = React.useRef(null);
    const loadingStatusRef = React.useRef(null);
    const emptyStatusRef = React.useRef(null);
    const retryRequestedRef = React.useRef(false);
    const retryFocusRemainsInSelectorRef = React.useRef(false);
    const selectionPrompt = getLocalSpecificString("confidenceCallSalesIdPlaceholder");
    const options = [
        { key: "", text: selectionPrompt },
        ...candidates.map((candidate) => ({
            key: candidate,
            text: candidate,
        })),
    ];
    React.useEffect(() => {
        setHasInteracted(false);
    }, [candidates, lookupStatus]);
    React.useEffect(() => {
        var _a, _b, _c, _d;
        if (!retryRequestedRef.current) {
            return;
        }
        if (lookupStatus === "loading") {
            (_a = loadingStatusRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            return;
        }
        retryRequestedRef.current = false;
        if (!retryFocusRemainsInSelectorRef.current) {
            return;
        }
        if (lookupStatus === "success") {
            (_b = dropdownRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
        else if (lookupStatus === "empty") {
            (_c = emptyStatusRef.current) === null || _c === void 0 ? void 0 : _c.focus();
        }
        else if (lookupStatus === "error") {
            (_d = retryButtonRef.current) === null || _d === void 0 ? void 0 : _d.focus();
        }
    }, [lookupStatus]);
    return (_jsx("div", Object.assign({ onFocusCapture: () => {
            if (retryRequestedRef.current) {
                retryFocusRemainsInSelectorRef.current = true;
            }
        }, onBlurCapture: (event) => {
            if (!retryRequestedRef.current) {
                return;
            }
            if (event.relatedTarget instanceof Node) {
                if (!event.currentTarget.contains(event.relatedTarget)) {
                    retryFocusRemainsInSelectorRef.current = false;
                }
                return;
            }
            retryFocusRemainsInSelectorRef.current = false;
        } }, { children: _jsxs(Stack, Object.assign({ tokens: { childrenGap: 8 } }, { children: [_jsx(Dropdown, { componentRef: dropdownRef, label: getLocalSpecificString("confidenceCallSalesIdLabel"), placeholder: selectionPrompt, options: options, selectedKey: selectedSalesId || null, required: candidates.length > 0, disabled: lookupStatus !== "success", errorMessage: lookupStatus === "success" && !selectedSalesId && hasInteracted
                        ? getLocalSpecificString("confidenceCallSalesIdRequired")
                        : undefined, onBlur: () => setHasInteracted(true), onChange: (_, option) => {
                        setHasInteracted(true);
                        onSelectionChange(option ? String(option.key) : "");
                    } }), lookupStatus === "loading" && (_jsx("div", Object.assign({ ref: loadingStatusRef, tabIndex: -1, "data-testid": "sales-id-loading-status" }, { children: _jsx(Spinner, { label: getLocalSpecificString("confidenceCallSalesIdLoading") }) }))), lookupStatus === "empty" && (_jsx("div", Object.assign({ ref: emptyStatusRef, tabIndex: -1 }, { children: _jsx(MessageBar, Object.assign({ delayedRender: false, messageBarType: MessageBarType.info }, { children: getLocalSpecificString("confidenceCallSalesIdEmpty") })) }))), lookupStatus === "error" && (_jsx(MessageBar, Object.assign({ delayedRender: false, messageBarType: MessageBarType.error, actions: _jsx(DefaultButton, { componentRef: retryButtonRef, text: getLocalSpecificString("confidenceCallSalesIdRetry"), onClick: () => {
                            retryRequestedRef.current = true;
                            retryFocusRemainsInSelectorRef.current = true;
                            onRetry();
                        } }) }, { children: getLocalSpecificString("confidenceCallSalesIdLookupError") })))] })) })));
};
export default CustomerMsSalesIdSelector;
